// Standalone dispatch kliku na legacy menu položku — bez React kontextu bridge
// (volá se z `MenuNavigationShellPage`, který může být mimo `<MagicControlBridge>`).
// Cílí na Magic desktop přes `getMagicDesktopFrame()` (reverse: control iframe).

import { getMagicDesktopFrame } from '@/shared/lib/legacyMagic';
import { PHOENIX_TO_MAGIC_ACTIONS } from './types';

/** Pošle Magic control instanci, že uživatel kliknul na položku menu (`menuItemId`). */
export function sendMagicMenuItemClick(menuItemId: string): void {
  const frame = getMagicDesktopFrame();
  if (!frame) return;
  frame.postMessage(
    {
      action: PHOENIX_TO_MAGIC_ACTIONS.desktopClickMenuItem,
      data: { menuItemId },
      requestId: crypto.randomUUID(),
    },
    '*'
  );
}
